import React from "react";
import RemoteTable from "../../components/ui/RemoteTable";
import { printFullDate } from "../../utils/time";
import { getInvoiceLink } from "../../services/fawaterkServices";
import payment from "../../services/paymentServices";
import modal from "../../services/modalServices";
import Button from "../../components/ui/Button";
import { useLanguage } from "../../context/LanguageContext";

const Invoices = () => {
    const { language } = useLanguage();

    const content = {
        columns: {
            sequence: { en: "Sequence", ar: "التسلسل", de: "Sequenz" },
            totalPrice: {
                en: "Total Invoice Price",
                ar: "اجمالي سعر الفاتورة",
                de: "Gesamtrechnungsbetrag",
            },
            discount: { en: "Discount", ar: "التخفيض", de: "Rabatt" },
            coupon: { en: "Coupon", ar: "الكوبون", de: "Gutschein" },
            quantity: { en: "Quantity", ar: "عدد المشتريات", de: "Menge" },
            purchases: { en: "Purchases", ar: "المشتريات", de: "Einkäufe" },
            paymentStatus: { en: "Payment Status", ar: "حالة الدفع", de: "Zahlungsstatus" },
            paymentTime: { en: "Payment Time", ar: "وقت الدفع", de: "Zahlungszeit" },
            paymentMethod: { en: "Payment Method", ar: "طريقة الدفع", de: "Zahlungsmethode" },
            invoiceId: { en: "Invoice ID", ar: "رقم الفاتورة", de: "Rechnungs-ID" },
            invoiceCreationTime: {
                en: "Invoice Creation Time",
                ar: "وقت انشاء الفاتورة",
                de: "Rechnungserstellungszeit",
            },
            noCoupon: {
                en: "-- No Coupon --",
                ar: "--لا يوجد كوبون--",
                de: "-- Kein Gutschein --",
            },
            noPurchases: {
                en: "-- No Purchases --",
                ar: "--لا توجد مشتريات--",
                de: "-- Keine Einkäufe --",
            },
            deletedPurchases: {
                en: "-- Deleted Purchases --",
                ar: "--تم حذف المشتريات--",
                de: "-- Gelöschte Einkäufe --",
            },
            paid: { en: "Paid", ar: "مدفوع", de: "Bezahlt" },
            unpaid: { en: "Unpaid", ar: "لم يتم الدفع", de: "Unbezahlt" },
        },
    };
    let columns = [
        {
            name: content.columns.sequence[language],
            reorder: true,
            selector: (row) => row.id,
            sortable: true,
            sortField: "id",
        },
        {
            name: content.columns.totalPrice[language],
            reorder: true,
            selector: (row) => row.total_price,
            sortable: true,
            sortField: "price",
        },
        {
            name: content.columns.discount[language],
            reorder: true,
            selector: (row) => row.discount,
            sortable: true,
            sortField: "discount",
        },
        {
            name: content.columns.coupon[language],
            reorder: true,
            selector: (row) =>
                row.used_coupon ? (
                    row.used_coupon.coupon.name
                ) : (
                    <div className="text-yellow-500">{content.columns.noCoupon[language]}</div>
                ),
        },
        {
            name: content.columns.quantity[language],
            reorder: true,
            selector: (row) => row.quantity,
            sortable: true,
            sortField: "quantity",
        },
        {
            name: content.columns.purchases[language],
            reorder: true,
            selector: (row) =>
                row.invoice_subscriptions && row.invoice_subscriptions.length > 0 ? (
                    row.invoice_subscriptions.map((value, index) =>
                        value.invoice_subscriptionable ? (
                            <div className="py-2" key={index}>
                                -- {value.invoice_subscriptionable.name}
                            </div>
                        ) : (
                            <div className="text-rose-500" key={index}>
                                {content.columns.deletedPurchases[language]}
                            </div>
                        )
                    )
                ) : row.quantity > 0 ? (
                    <div className="text-rose-500">
                        {content.columns.deletedPurchases[language]}
                    </div>
                ) : (
                    <div className="text-yellow-500">{content.columns.noPurchases[language]}</div>
                ),
        },
        {
            name: content.columns.paymentStatus[language],
            reorder: true,
            selector: (row) => (
                <>
                    {row.invoice_provider == "fawry_ref" ? (
                        <div>
                            <Button
                                color={`${row.invoice_status === "paid" ? "cyan" : "rose"}`}
                                onClick={() =>
                                    modal.message({
                                        title: content.columns.paymentStatus[language],
                                        text: `رقمك المرجعي هو : ${row.reference_number} , \n توجه نحو اقرب فرع خدمة لفوري و اطلب الدفع على خدمة رقم ٧٨٨ بهذا الكود المرجعي`,
                                    })
                                }
                            >
                                {row.invoice_status === "paid"
                                    ? content.columns.paid[language]
                                    : content.columns.unpaid[language]}
                            </Button>
                        </div>
                    ) : (
                        <div>
                            <a
                                target="_blank"
                                rel="noreferrer"
                                href={payment.getInvoiceUrl(row)}
                                className="underline"
                            >
                                {row.invoice_status === "paid" ? (
                                    <div className="py-1 px-2 rounded-md bg-cyan-500 clr-white">
                                        {content.columns.paid[language]}
                                    </div>
                                ) : (
                                    <div className="py-1 px-2 rounded-md bg-rose-500 clr-white">
                                        {content.columns.unpaid[language]}
                                    </div>
                                )}
                            </a>
                        </div>
                    )}
                </>
            ),
            sortable: true,
            sortField: "invoice_status",
        },
        {
            name: content.columns.paymentTime[language],
            reorder: true,
            selector: (row) =>
                row.invoice_status === "paid" ? (
                    row.payment_time ? (
                        printFullDate(row.payment_time)
                    ) : (
                        "--"
                    )
                ) : (
                    <div className="text-yellow-500">{content.columns.unpaid[language]}</div>
                ),
            sortable: true,
            sortField: "payment_time",
        },
        {
            name: content.columns.paymentMethod[language],
            reorder: true,
            selector: (row) =>
                row.invoice_status === "paid" ? (
                    row.payment_method
                ) : (
                    <div className="text-yellow-500">{content.columns.unpaid[language]}</div>
                ),
            sortable: true,
            sortField: "payment_method",
        },
        {
            name: content.columns.invoiceId[language],
            reorder: true,
            selector: (row) => (
                <div>
                    <a
                        target="_blank"
                        rel="noreferrer"
                        href={getInvoiceLink(row.invoice_id, row.invoice_key)}
                        className="underline"
                    >
                        {row.invoice_id}
                    </a>
                </div>
            ),
            sortable: true,
            sortField: "invoice_id",
        },
        {
            name: content.columns.invoiceCreationTime[language],
            reorder: true,
            selector: (row) => printFullDate(row.created_at, language),
            sortable: true,
            sortField: "created_at",
        },
    ];
    return (
        <div>
            <div className="w-full">
                <RemoteTable
                    isAdmin={false}
                    api={`/api/user/invoices/paginate`}
                    columns={columns}
                />
            </div>
        </div>
    );
};

export default Invoices;
